export const STORAGE_KEYS = {
  SHOW_DETAILED_INFO: 'showDetailedInfo',
} as const;

export const THEME = {
  FONTS: {
    JAPANESE: '"Noto Serif JP", serif',
    JAPANESE_SANS: '"Noto Sans JP", sans-serif',
    MONOSPACE: 'monospace',
  },
  SIZES: {
    ICON: {
      DEFAULT: 16,
    },
  },
} as const;

export const REGEX = {
  KANJI: /[\u4e00-\u9faf]/,
  KANA: /[\u3040-\u309f\u30a0-\u30ff]/,
} as const;